var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"cy-data":"submit","type":"submit","disabled":_vm.isSubmitting},on:{"click":function($event){return _vm.submitForm()}}},[_vm._t("default"),_vm._v("\n  "+_vm._s(_vm.buttonValue)+"\n")],2)}
var staticRenderFns = []

export { render, staticRenderFns }